import 'core-js/stable';
import lozad from "lozad";
import LazyLoad from "vanilla-lazyload";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger.js";
import {MobileMenu} from "./components/mobile-menu";
import {initContactsForm} from "./components/contacts-form";
import {initMainPageLanding} from "./landings/mainPage";
import {initAboutUsPageLanding} from "./landings/aboutUsPage";
import {initProductsPageLanding} from "./landings/productsPage";
import {initInformationPageLanding} from "./landings/InformationPage";

$( document ).ready(function() {
    const mobileMenu = new MobileMenu();
    const lazyLoadInstance = new LazyLoad();
    const observer = lozad();

    observer.observe();
    gsap.registerPlugin(ScrollTrigger);

    if ($('#preloader').length) {
        initPreloader();
    }

    if ($('#main_page_landing').length) {
        initHeaderEffects();
        initMainPageLanding();
    }

    if ($('#about_us_page_landing').length) {
        initAboutUsPageLanding();
    }

    if ($('#products_page_landing').length) {
        initProductsPageLanding();
    }

    if ($('#information_page_landing').length) {
        initInformationPageLanding();
    }

    if ($('#write_to_us_landing').length) {
        initInformationPageLanding();
    }

    $('body').on('click', '.mobile-menu-toggle-button', function () {
        mobileMenu.toggle();
        return false;
    });

    initContactsForm();

    const isProducts = $('div[data-url="/products/"]').length;
    const isMainPage = $('div[data-url="/main/"]').length;

    if (isProducts) {
        $('a').on('click', () => {
            const scroll = $('html').scrollTop();
            sessionStorage.setItem('lastScrollProducts', `${scroll}`);
        });
    }

    if (isMainPage) {
        $('a').on('click', () => {
            const scroll = $('html').scrollTop();
            sessionStorage.setItem('lastScrollMain', `${scroll}`);
        });
    }


    let isProductsLastPosition = sessionStorage?.getItem('lastPositionProducts')?.includes('products');
    let isMainPageLastPosition = sessionStorage?.getItem('lastPositionMain')?.includes('main');

    if (sessionStorage.getItem('lastScrollProducts') && isProducts && isProductsLastPosition) {
        $('html').scrollTop(+sessionStorage.getItem('lastScrollProducts'));
        sessionStorage.setItem('lastScrollProducts', '0');
        sessionStorage.setItem('lastPositionProducts', 'no');
    }

    if (sessionStorage.getItem('lastScrollMain') && isMainPage && isMainPageLastPosition) {
        $('html').scrollTop(+sessionStorage.getItem('lastScrollMain'));
        sessionStorage.setItem('lastScrollMain', '0');
        sessionStorage.setItem('lastPositionMain', 'no');
    }

    if (window.location.pathname.includes('products')) {
        console.log('in pathname');
        sessionStorage.setItem('lastPositionProducts', window.location.pathname);
    }

    if (window.location.pathname === '/') {
        sessionStorage.setItem('lastPositionMain', 'main');
    }

});


function initPreloader() {
    const preloader = $('#preloader');
    const layerLightBlue = preloader.find('.light-blue');
    const layerBlue = preloader.find('.blue');
    const layerLogo = preloader.find('.preloader-logo');
    const pageLoaded = sessionStorage.getItem('pageLoaded');
    const tl = gsap.timeline();

    function hidePreloader() {
        preloader.addClass('hide');
        sessionStorage.setItem('pageLoaded', 'true');
    }


    if (!pageLoaded) {
        preloader.removeClass('hide');
        tl.to(layerLogo, {duration: 3.5, opacity: 0.1, scale: 1.5, onComplete: hidePreloader })
          .to(preloader, {duration: 0.5, opacity: 0,}, "-=0.5")
          .to(layerLightBlue, {duration: 0.5, scale: 1, ease: 'Power1.In'}, "-=3.1")
          .to(layerBlue, {duration: 0.3, scale: 1, ease: 'Power1.In'}, "-=2.9");
    } else {
        hidePreloader();
    }
}

function initHeaderEffects() {
    const tabletWidth = 1000;
    const pageLoaded = sessionStorage.getItem('pageLoaded');
    const delay = pageLoaded ? 0 : 3.5;
    const tl = gsap.timeline();
    let header = $('#header');

    if ($(window).width() <= tabletWidth) header = $('#header_mobile');

    tl.from(header, {duration: 1, delay: delay, translateY: '-100%'})
      .from(header, {duration: 1, opacity: 0.1}, "-=0.5");
}

